/**
 * Labstep
 *
 * @module Layout/Topbar/Help
 * @desc Help dropdown
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { intercomService } from 'labstep-web/services/intercom.service';
export const Help = () => (
  <ActionComponent
    type="icon"
    icon="question"
    elementProps={{
      color: 'blue',
      popup: { content: 'Help' },
    }}
    onClick={intercomService.open}
  />
);
